import {
  DeleteScheduleActionTypes,
  DELETE_SCHEDULE_FAIL,
  DELETE_SCHEDULE_LOADING,
  DELETE_SCHEDULE_SUCCESS,
  DeleteScheduleState,
  DELETE_SCHEDULE_UPDATE_API_MSG,
  DELETE_SCHEDULE_UPDATE_API_RES,
} from "./ActionTypes";
import { DeleteScheduleRes } from "./Model";

const initialStateGetPosts: DeleteScheduleState = {
  loading: false,
  deleteScheduleRes: {} as DeleteScheduleRes,
  successMsg: "",
  errorMsg: "",
  status: 0,
};
export const deleteScheduleReducer = (
  state = initialStateGetPosts,
  action: DeleteScheduleActionTypes
): DeleteScheduleState => {
  switch (action.type) {
    case DELETE_SCHEDULE_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case DELETE_SCHEDULE_SUCCESS:
      return {
        ...state,
        deleteScheduleRes: action.payload,
        successMsg: action.successMsg,
      };
    case DELETE_SCHEDULE_FAIL:
      return {
        ...state,
        deleteScheduleRes: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case DELETE_SCHEDULE_UPDATE_API_MSG:
      return {
        ...state,
        deleteScheduleRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case DELETE_SCHEDULE_UPDATE_API_RES:
      return {
        ...state,
        deleteScheduleRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};
